import React from "react";
import { Box, Typography } from "@mui/material";
export const TemperatureDisplay = ({ temperature, leftIndicator, rightIndicator, width = 66, height = 56, color = "#1D95E2", }) => {
    const displayTemperature = temperature == null ? "--.-" : Number(temperature).toFixed(1);
    const showLeft = leftIndicator != null;
    const showRight = rightIndicator != null;
    const normalizedColor = (color === null || color === void 0 ? void 0 : color.startsWith("#")) && color.length === 9
        ? `#${color.slice(1, 7).toLowerCase()}`
        : (color || "").toLowerCase();
    let outerStyles = {
        backgroundColor: "#1D95E23D",
        boxShadow: "0px 8px 16px 0px #1D95E23D",
        valueColor: "#00478D",
    };
    if (normalizedColor === "#ff5630") {
        outerStyles = {
            backgroundColor: "#FF56303D",
            boxShadow: "0px 8px 18px 0px #FF56303D",
            valueColor: "#7A0916",
        };
    }
    else if (normalizedColor === "#919eab" || normalizedColor === "#94a3b8") {
        outerStyles = {
            backgroundColor: "#919EAB3D",
            boxShadow: "0px 8px 16px 0px #919EAB3D",
            valueColor: "#161C24",
        };
    }
    const indicatorSize = 18;
    const indicatorFontSize = 10;
    const innerRadius = 14;
    const innerHeight = 30;
    const innerWidth = 65;
    return (React.createElement(Box, { sx: {
            width,
            height,
            borderRadius: 2,
            backgroundColor: outerStyles.backgroundColor,
            boxShadow: outerStyles.boxShadow,
            position: "relative",
            display: "flex",
            alignItems: "center",
            zIndex: 5,
            justifyContent: "center",
        } },
        React.createElement(Box, { sx: {
                width: innerWidth,
                height: innerHeight,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#FFFFFF",
                borderRadius: 1,
                boxShadow: "0px 4px 8px 0px #919EAB29",
                zIndex: 1,
            } },
            React.createElement(Box, { sx: {
                    display: "flex",
                    alignItems: "baseline",
                    justifyContent: "center",
                    gap: 0.4,
                    color: outerStyles.valueColor,
                    fontFamily: "Orbitron, sans-serif",
                    userSelect: "none",
                    lineHeight: 1,
                } },
                React.createElement(Typography, { fontWeight: 500, variant: "body2" }, displayTemperature),
                React.createElement(Box, { component: "span", sx: {
                        fontSize: 11,
                        fontWeight: 500,
                        position: "relative",
                        top: 0,
                    } }, "\u00B0C"))),
        showLeft ? (React.createElement(Box, { sx: {
                width: indicatorSize,
                height: indicatorSize,
                borderRadius: "50%",
                bgcolor: "#1D95E2",
                color: "#FFFFFF",
                position: "absolute",
                bottom: 3,
                left: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: indicatorFontSize,
                fontFamily: "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
                zIndex: 2,
            } }, leftIndicator)) : null,
        showRight ? (React.createElement(Box, { sx: {
                width: indicatorSize,
                height: indicatorSize,
                borderRadius: "50%",
                bgcolor: "#F4F6F8",
                color: "#161C24",
                position: "absolute",
                bottom: 3,
                right: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: indicatorFontSize,
                border: "1px solid rgba(15, 23, 42, 0.06)",
                zIndex: 2,
            } }, rightIndicator)) : null));
};
export default TemperatureDisplay;
